import { AlertWithActionsType } from '@masfront/common-b2c'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SaleResponse, SaleRequest, SaleError } from '../model/checkout.model'

export interface createCheckoutItemRequest {
  id: string
}
export interface LineSaleRequest {
  saleRequest: SaleRequest
  id: string
}
export interface LineSaleResponse {
  status: AlertWithActionsType
  saleResponse: SaleResponseStatus
  id: string
}
export interface SaleResponseStatus {
  data?: SaleResponse | null
  error?: SaleError | null
  httpStatus?: number | null
}

export interface CheckoutItemState {
  saleResponse: SaleResponseStatus
  status: AlertWithActionsType
}

export type CheckoutState = {
  [key: string]: CheckoutItemState
}

export const initialState: CheckoutState = {}

export const initialItemState: CheckoutItemState = {
  saleResponse: {
    data: null,
    error: null,
    httpStatus: null,
  },
  status: AlertWithActionsType.info,
}

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    createCheckoutItem: (state, action: PayloadAction<createCheckoutItemRequest>) => {
      const {
        payload: { id },
      } = action

      return {
        ...state,
        [id]: {
          ...initialItemState,
        },
      }
    },
    createOrder: (state, action: PayloadAction<LineSaleRequest>) => {
      const {
        payload: { id },
      } = action
      return {
        ...state,
        [id]: {
          ...state[id],
          status: AlertWithActionsType.loading,
        },
      }
    },
    setOrderStatus: (state, action: PayloadAction<LineSaleResponse>) => {
      const {
        payload: {
          id,
          saleResponse: { data, error, httpStatus },
          status,
        },
      } = action
      return {
        ...state,
        [id]: {
          ...state[id],
          saleResponse: {
            ...state[id].saleResponse,
            data,
            error,
            httpStatus,
          },
          status,
        },
      }
    },
    resetCheckout: () => {
      return {}
    },
  },
})

export const {
  createCheckoutItem,
  createOrder,
  setOrderStatus,
  resetCheckout,
} = checkoutSlice.actions

const checkoutReducer = checkoutSlice.reducer
export default checkoutReducer
